import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateFormatHubTest'
})

export class DateFormatPipeHubTest implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  public transform(value?: string): string {
    let format;
    let locale;

    try {
      if (value != null) {
        this.translateService.get('date.displayFormat').subscribe(v => { format = v; });
        this.translateService.get('date.locale').subscribe(v => { locale = v; });
        const date = this.parseDate(value);
        var d = formatDate(date, format, locale);
        return d;
      }
      else {
        return "";
      }
    }
    catch {
      return value;
    }
  }

  private parseDate(value: string): Date | null {
    // Assume format like '01-Jul-2025 05:03'
    // Split at the ' ' to separate date and time+offset
    const [datePart, timePart] = value.split(' ');
    const [day, month, year] = datePart.split('-');
    const isoString = `${year}-${month}-${day}T${timePart}`;
    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
      const isoString = `${year}-${day}-${month}T${timePart}`;
      return new Date(isoString);
    } else {
      return date;
    }
  }

}
